'use client';

import { HelpCircle } from 'lucide-react';
import { useGuidedTour } from './GuidedTourProvider';
import { Button } from '@/components/ui/button';

interface GuidedTourLauncherProps {
  moduleKey?: string;
  flowId?: string;
  label?: string;
  className?: string;
}

export function GuidedTourLauncher({
  moduleKey,
  flowId,
  label = 'Take a tour',
  className,
}: GuidedTourLauncherProps) {
  const { isOpen, openTour } = useGuidedTour();

  if (isOpen) {
    return null;
  }

  return (
    <Button
      size="sm"
      variant="outline"
      className={className}
      onClick={() => openTour({ moduleKey, flowId })}
    >
      <HelpCircle className="mr-2 h-4 w-4" />
      {label}
    </Button>
  );
}
